module.exports = __webpack_public_path__ + "static/cirp_img-cca23f644439093836584290f5936b1a.png";